import React from 'react';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';

import getCookie from 'common/utils/getCookie';
import getCsrfCookieName from 'common/utils/csrfCookieName';
import { getErrorMessage } from 'common/utils/errors';
import { AxiosError } from 'axios';
import BaseService from 'common/services/baseService';
import useDialog from '../dialog-provider/useDialog';

const baseService = new BaseService();
const Logout = () => {
  const csrftoken: unknown = getCookie(getCsrfCookieName());
  const { displayDialog } = useDialog();

  const handleLogout = async (e: any) => {
    e.preventDefault();
    try {
      await baseService.post('/api/auth/logout/', {});
      window.location.href = '/accounts/login';
    } catch (error) {
      displayDialog({
        title: 'Error!',
        content: '',
        variant: 'error',
        agreeText: 'Retry',
        onAgree: (closeDialog: any) => {
          closeDialog();
        },
        onDisagree: () => {},
        children: (
          <Typography variant="subtitle2">
            {getErrorMessage((error as AxiosError).response?.data)}
          </Typography>
        ),
      });
    }
  };

  return (
    <form onSubmit={handleLogout}>
      <input
        type="hidden"
        name="csrfmiddlewaretoken"
        value={typeof csrftoken === 'string' ? csrftoken : ''}
      />
      <MenuItem
        component="button"
        style={{ width: '100%' }}
        type="submit"
      >
        Logout
      </MenuItem>
    </form>
  );
};

export default Logout;
